const zIndices = [0, 1, 2, 4, 6, 12];

export default zIndices;
